import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import {
  jwtApiClient,
  jwtApiClientFile,
} from "@/apps/merchant3/services/apiClient/apiClient";

/**
 * To get the credit check permission document HTML
 * @param cartTag string
 * @param locale string
 * @returns document HTML
 */
export const getCreditCheckPermission = async (
  cartTag: string,
  locale?: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.get(M3_API().CREDIT_CHECK_PERMISSION, {
    params: {
      cartTag,
      locale,
    },
  });
};

/**
 * To post the credit check permission signature
 * @param cartTag string
 * @param file FormData
 * @param locale string
 * @returns creditCheckPermittedTimestamp number
 */

export const creditCheckSignature = async (
  cartTag: string,
  file: FormData,
  locale?: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClientFile.post(M3_API(cartTag).SIGN_CREDIT_CHECK, file, {
    params: {
      locale,
    },
  });
};

export const authorizeCreditCheck = (
  cartTag: string,
  permissionType: string
): Promise<AxiosResponse<unknown>> => {
  return jwtApiClient.put(M3_API(cartTag).AUTHORIZE_CREDIT_CHECK, {
    permissionType,
  });
};
